// extracted by mini-css-extract-plugin
module.exports = {"product-slider":"ProductSlider_product-slider__YWNR7","image":"ProductSlider_image__ZsHQs","product-image":"ProductSlider_product-image__XObAE"};